import { FormattedMessage, injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { AutoDismissFlag } from '@atlaskit/flag';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import SimpleTag from '@atlaskit/tag/simple-tag';
import { token } from '@atlaskit/tokens';

import { getDeleteBranchDialogSlice } from 'src/redux/branches';
import { BucketState } from 'src/types/state';

import { messages } from './delete-branch-success-flag.i18n';

type Props = {
  id: string;
  branchName: string;
  intl: IntlShape;
};

const SuccessFlag = ({ branchName, intl, ...otherProps }: Props) => (
  <AutoDismissFlag
    {...otherProps}
    icon={
      <CheckCircleIcon
        spacing="spacious"
        label="success"
        color={token('color.icon.success')}
      />
    }
    title={intl.formatMessage(messages.deleteBranchSuccessTitle)}
    description={
      <FormattedMessage
        {...messages.deleteBranchSuccessDescription}
        values={{ branchLabel: <SimpleTag text={branchName} /> }}
      />
    }
  />
);

const mapStateToProps = (state: BucketState) => {
  const {
    successFlag: { branchName },
  } = getDeleteBranchDialogSlice(state);

  return {
    branchName,
  };
};

export const DeleteBranchSuccessFlag = compose<any, any, any>(
  injectIntl,
  connect(mapStateToProps)
)(SuccessFlag);
